var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numOfAddOns > 0)?_c('v-chip',{staticClass:"add-on-badge"},[_c('i',{staticClass:"fa fa-cube"}),_vm._v(_vm._s(_vm.addOnBadgeLabel))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }